// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PnsGw","question":"styles_question__lV43o","description":"styles_description__23eNM"};